// No-op Logger stub — xtracker does not phone home.
var Logger = function(){
	var me = {};
	me.info = function(){};
	me.warn = function(m){ console.warn(m); };
	me.error = function(m){ console.error(m); };
	return me;
}();

export default Logger;
